import { NAME } from './constants';
import reducer from './reducer';
import routes from './routes';

export default {
  NAME, reducer, routes
};
